export default "__VITE_ASSET__9Xr5B37S__"